import React, { useRef } from 'react';
import { Currency, Interval, maxAnnualSavingsPercent } from '../../Data/PricingData';
import '../../Styles/Pricing/BillingToggle.css';

interface BillingToggleProps {
    billingCycle: Interval;
    setBillingCycle: (cycle: Interval) => void;
    currency: Currency;
}

const OPTIONS: Interval[] = ['monthly', 'annual'];

const BillingToggle: React.FC<BillingToggleProps> = ({ billingCycle, setBillingCycle, currency }) => {
    const refs = useRef<Record<Interval, HTMLButtonElement | null>>({ monthly: null, annual: null });
    const savings = maxAnnualSavingsPercent(currency);

    const onKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const next = billingCycle === 'monthly' ? 'annual' : 'monthly';
        setBillingCycle(next);
        refs.current[next]?.focus();
    };

    return (
        <div className="billing-toggle" role="radiogroup" aria-label="Billing period">
            {OPTIONS.map(option => {
                const selected = billingCycle === option;
                return (
                    <button
                        key={option}
                        ref={el => { refs.current[option] = el; }}
                        type="button"
                        role="radio"
                        aria-checked={selected}
                        tabIndex={selected ? 0 : -1}
                        className={`billing-toggle-option ${selected ? 'is-selected' : ''}`}
                        onClick={() => setBillingCycle(option)}
                        onKeyDown={onKeyDown}
                    >
                        {option === 'monthly' ? 'Monthly' : 'Yearly'}
                        {option === 'annual' && savings > 0 && (
                            <span className="billing-toggle-save">Save Up to {savings}%</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
};

export default BillingToggle;
